<template>
  <!-- Diálogo para elegir la distancia del buffer -->
  <v-scale-transition>
    <v-card flat v-show="value" :color="$store.getters.isDarkTheme ? 'grey darken-4' : 'grey lighten-4'">      
      <v-toolbar 
        style="cursor: pointer;"
        @click="collapsed = !collapsed" :color="`green ${$store.getters.isDarkTheme ? 'darken-2' : 'lighten-2'}`">
        <v-btn icon>
          <buffer-icon style="font-size: 24px;"></buffer-icon>
        </v-btn>
        <v-toolbar-title style="font-size: 16px;">{{$t('_busquedas.buffer')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text class="py-0">
        <v-slider v-model="bufferDistance" :min="min" :max="max" :step="step" :thumb-label="true" hide-details class="pt-0"></v-slider>

        <v-flex xs12 class="text-xs-center px-3">
          <h3>{{bufferDistance}} m</h3>  
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="$emit('cancel')" flat color="red">{{ $t('cancelar') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="bufferSearch" flat color="green">{{ $t('aceptar') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-scale-transition>
</template>


<script>
import VectorLayer from 'ol/layer/vector'
import VectorSource from 'ol/source/vector'
import FormatGeoJSON from 'ol/format/geojson'
import OLExtent from 'ol/extent'

import buffer from '@turf/buffer'
import difference from '@turf/difference'

import styleDraw, { styleBuffer } from '../style'

const GeoJSONParser = new FormatGeoJSON
const LayerDraw = new VectorLayer({ source: new VectorSource, style: styleBuffer })

/**
 * Componente para crear buffers a partir de una feature
 */
export default {
  props: ['value', 'map', 'feature'],

  data() {
    return {
      bufferDistance: 50,
      min: 50,
      max: 1000,
      step: 50,
      lastFeature: null
    }
  },

  methods: {

    bufferSearch() {
      this.$emit('selected', this.lastFeature)
    },

    showBufferDistance() {
      if(!this.feature) {
        return
      }

      this.lastFeature = this.getBufferFeature()
      const extent = this.lastFeature.getGeometry().getExtent()

      let poly1 = this.lastFeature.clone()
      let poly2 = this.feature.clone()

      poly1.getGeometry().transform(this.map.getView().getProjection(), 'EPSG:4326')
      poly2.getGeometry().transform(this.map.getView().getProjection(), 'EPSG:4326')

      poly1 = GeoJSONParser.writeFeatureObject(poly1)
      poly2 = GeoJSONParser.writeFeatureObject(poly2)

      // console.log(difference(poly1, poly2))

      const featureErased = GeoJSONParser.readFeature(difference(poly1, poly2), {
        dataProjection: 'EPSG:4326', 
        featureProjection: this.map.getView().getProjection()
      })

      // console.log(featureErased, 'featureErased')

      LayerDraw.getSource().clear()
      LayerDraw.getSource().addFeature(featureErased)

      const handle = () => this.map.getView().fit(OLExtent.buffer(extent, 0), { duration: 150 })
    
      requestAnimationFrame(handle)
    },

    getBufferFeature() {
      const lastFeature = this.feature.clone()

      lastFeature.getGeometry().transform(this.map.getView().getProjection(), 'EPSG:4326')

      const turfFeature = GeoJSONParser.writeFeatureObject(lastFeature)
      const bufferFeatureGeoJSON = buffer(turfFeature, this.bufferDistance, {units: 'meters'})

      LayerDraw.getSource().clear()

      return GeoJSONParser.readFeature(bufferFeatureGeoJSON, {
        dataProjection: 'EPSG:4326', 
        featureProjection: this.map.getView().getProjection()
      })
    },

  },

  watch: {
    value() {
      this.bufferDistance = 50

      LayerDraw.getSource().clear()
      LayerDraw.setMap(this.value ? this.map : null)

      LayerDraw.setStyle(styleDraw)
      this.value && LayerDraw.setStyle(styleBuffer)

      this.showBufferDistance()
    },

    bufferDistance() {
      this.value && this.showBufferDistance()
    },

    feature() {
      this.lastFeature = this.feature
    }

  }
}
</script>



// WEBPACK FOOTER //
// buffer-feature.vue?abc3a448